import applicationsData, {undefinedApplicationData} from "@/modules/Applications/service/applicationsData.js";

export function normalizeApplication(application) {
    const appType = application.type.split('.')[0];
    for (let applicationData of applicationsData) {
        if (appType === applicationData.mainType) {
            return {
                ...applicationData,
                ...application
            };
        }
    }

    return {
        ...application,
        ...undefinedApplicationData,
    };
}